import TalentCandidate from "../models/TalentCandidate";
import ProjectPosition from "../models/ProjectPosition";
import ProjectGroup from "../models/ProjectGroup";
import User from "../models/User";
import Project from "../models/Project";
import {searchForTalent} from "./ClientRequests"

const positionMatches = ({queryKey, signal}) => {

    return searchForTalent({queryKey, signal});
}

const getPositionMatchingTalentCount = ({queryKey, signal}) => {
    const params = queryKey[1] || {};  // queryKey[0] is the original query key

    return Project.getMatchingUserCountForPosition(params.projectId, params.positionId, params?.visibilitySettings, {signal});
}

const searchDeliverablesByDisciplines = ({queryKey, signal}) => {
    const params = queryKey[1] || {};

    return ProjectPosition.fetchDeliverablesForDisciplines(params.disciplines, {signal})
}

const fetchSharableForPosition = async({queryKey, signal}) => {
    const params = queryKey[1] || {};  // queryKey[0] is the original query key

    return ProjectPosition.fetchSharable(params.project_id, params.position_id, {signal})
}
const fetchTalentCandidateScope = async ({queryKey, signal}) => {
    const candidateId = queryKey[1];  // queryKey[0] is the original query key

    if (!candidateId) {
        throw new Error("Something went wront")
    }
    return TalentCandidate.fetchTalentCandidateScope(candidateId, {signal})
}
const searchCandidates = ({queryKey, signal}) => {

    return searchForTalent({queryKey, signal});
}

const fetchRecipientUsers = async ({queryKey, signal}) => {
    const params = queryKey[1] || {};
    let recipients = [];


    // console.log('fetchRecipientUsers', params)
    if (params.group && !params.queryParams?.length) {

        const client_id = TB.auth().user()?.clientOrg?.().id;
        let groupResponse = await ProjectGroup.fetchAllForClient(client_id, {signal});

        if (!groupResponse?.groups) {
            throw new Error(ProjectGroup.FetchGroupRequest.response);
        }
        // console.log('fetchGroups',groupResponse.groups, params.group);

        let project_group = TB.find(groupResponse.groups, ['id', params.group?.id]);
        if (!project_group) {
            throw new Error("Can't find project group");
        }
        if (project_group) {
            recipients = project_group.members;
        }

    } else {
        // console.log('fetchRecipientUsers')
        recipients = await User.fetchAllForClient({signal}, params.queryParams || '');

        if (!recipients) {
            throw new Error(User.FetchAllForClientRequest.response);
        }
    }

    return recipients;
}

const searchPositionTemplateTags = async ({queryKey, signal}) => {
    if (!queryKey[1]?.length) return [];
    const request = TB.request(
        TB.api_endpoint(`/api/position-templates/keywords/search?search=${queryKey[1]}`)
    )

    let response = await request.get({signal});

    return TB.get(response, 'success.data.tags', [])
}
export {
    positionMatches,
    getPositionMatchingTalentCount,
    fetchSharableForPosition,
    searchDeliverablesByDisciplines,
    fetchTalentCandidateScope,
    searchCandidates,
    fetchRecipientUsers,
    searchPositionTemplateTags
}